import React from 'react'

import fullscreen from './../../../UI/canvas/topMenu/fullscreen.svg'
import sound_on from './../../../UI/canvas/topMenu/sound_on.svg'
import tutorial from './../../../UI/canvas/topMenu/tutorial.svg'

interface Props{
    handleOpenVideo: any
}

interface State{}

class TopMenuMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {

        }
    }

    render(): React.ReactNode {
        return(
            <div className='top-menu-container-mobile'>
                <div className='top-menu-btn' onClick={() => {this.props.handleOpenVideo("https://www.youtube.com/embed/nLY8rUQxeX8")}}>
                    <img src={tutorial}/>
                </div>
                {/*<div className='top-menu-btn'>
                    <img src={sound_on}/>
                </div>
                <div className='top-menu-btn'>
                    <img src={fullscreen}/>
                </div>*/}
            </div>
        )
    }
}

export default TopMenuMobile